import React from 'react'
import {
  Modal,
  Typography,
  IconButton,
  TextField,
  Button,
  AppBar,
  Tab,
  Tabs,
  Table,
  TableCell,
  TableBody,
  TableRow,
  Checkbox,
  Grid,
  FormControlLabel,
} from '@material-ui/core'
import {FormControl} from 'react-bootstrap'
import LikeNotLike from './LikeNotLike'

export default function TextInputField({
  type,
  idx,
  onChange = (e, key, value, typeId) => {},
  data,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <LikeNotLike type={type} onChange={onChange} idx={idx} data={data} />
      </Grid>
      <Grid item xs={8}>
        {type.name === 'name' ? (
          <TextField
            variant="outlined"
            className="ap-textfield"
            label="Name"
            defaultValue={data?.fix_value}
            onChange={e =>
              onChange(e, 'list_filters_attributes', e.target.value, 'fix_value', idx, '', type.id)
            }
            style={{width: '100%', marginTop: 16}}
          />
        ) : type.name === 'Address' ? (
          <FormControl
            as="textarea"
            aria-label="With textarea"
            className="max-height-100 min-height-100 z-index-100"
            defaultValue={data?.fix_value}
            onChange={e =>
              onChange(e, 'list_filters_attributes', e.target.value, 'fix_value', idx, '', type.id)
            }
            style={{width: '100%', marginTop: 16}}
          />
        ) : type.name === 'number' ? (
          <TextField
            variant="outlined"
            className="ap-textfield"
            label="Number"
            id="number"
            defaultValue={data?.fix_value}
            type="number"
            onChange={e =>
              onChange(e, 'list_filters_attributes', e.target.value, 'fix_value', idx, '', type.id)
            }
            style={{width: '100%', marginTop: 16}}
          />
        ) : (
          <TextField
            variant="outlined"
            className="ap-textfield"
            defaultValue={data?.fix_value}
            onChange={e =>
              onChange(e, 'list_filters_attributes', e.target.value, 'fix_value', idx, '', type.id)
            }
            style={{width: '100%', marginTop: 16}}
          />
        )}
      </Grid>
    </Grid>
  )
}
